import { getAuthHeaders, tempMeeApi } from '~/services/api';

const MONOLITH_NPS_REVIEW_PATH = '/nps-review';

/**
 * Records an NPS answer on the monolith, where a skip is the score `-1`. The
 * flag-off path of GOTU-7479; GOTU-16478 deletes it with the flag.
 */
export const submitMonolithNpsReview = async (score: number): Promise<void> => {
  const headers = await getAuthHeaders();
  await tempMeeApi.post(MONOLITH_NPS_REVIEW_PATH, { score }, { headers });
};
